/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-03-07",
    versionChannel: "nightly",
    buildDate: "2023-03-07T00:21:29.218Z",
    commitHash: "c5f30dcae1896609f3865b628b8a480a8f2dc7bb",
};
